import {NotificationItemGroup} from './notification-item-group';

export type CountItem = { iconName: string | null, count: number, labelText: string };

export abstract class MultiCountNotificationItemGroup extends NotificationItemGroup {

  abstract get countItems(): Array<CountItem>;
}
